import React from 'react'
import { Alert } from 'react-bootstrap'

interface AlertProps {
  variant: string,
  id: string,
  message: string,
  className: string
}


export const AlertComponent: React.FC<AlertProps> = ({
  variant,
  id,
  message,
  className
}) => {
  return (
    <Alert key={id} variant={variant} className={className}>
      {message}
    </Alert>
  )
}
